const ScreenshotsRoutes = [
  {
    path: "screenshots",
    name: "Screenshots",
    redirect: {
      name: "Screenshots List"
    },
    component: () =>
      import(/* webpackChunkName: "Screenshots" */ "../../views/screenshots/Screenshots.vue"),
    children: [
      {
        path: "list",
        name: "Screenshots List",
        component: () =>
          import(/* webpackChunkName: "Screenshots" */ "../../views/screenshots/ScreenshotsList.vue")
      }
    ]
  }
];

export default ScreenshotsRoutes;
